import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { PrismicLink } from '@prismicio/react'

const Social = ({ networks }) => {
  return (
    <>
      {networks.body.map((social, index) => {
        return (
          <PrismicLink className='social-icon mx-2 inline-block w-5 transform hover:scale-105' href={social.primary.social_network_url.url} target='_blank' key={`social-${index}`}>
            <span className='sr-only'>{social.primary.social_network}</span>
            {social.primary.social_network.toLowerCase() === 'facebook' && <StaticImage src='../images/facebook.png' alt='Visit us on Facebook' placeholder='blurred' layout='fixed' width={20} />}
            {social.primary.social_network.toLowerCase() === 'youtube' && <StaticImage src='../images/youtube.png' alt='Visit us on YouTube' placeholder='blurred' layout='fixed' width={20} />}
            {social.primary.social_network.toLowerCase() === 'instagram' && <StaticImage src='../images/instagram.png' alt='Visit us on Instagram' placeholder='blurred' layout='fixed' width={20} />}
            {social.primary.social_network.toLowerCase() === 'linkedin' && <StaticImage src='../images/linkedin.png' alt='Visit us on LinkedIn' placeholder='blurred' layout='fixed' width={20} />}
            {social.primary.social_network.toLowerCase() === 'twitter' && <StaticImage src='../images/twitter.png' alt='Visit us on twitter' placeholder='blurred' layout='fixed' width={20} />}
          </PrismicLink>
        )
      })}
    </>
  )
}

export default React.memo(Social)
